import { BaseModel } from './base.model';
import { UserModel } from './user.model';

export class ChecklistResponseModel extends BaseModel {

    user: UserModel;

    constructor(checklistResponse?: ChecklistResponseModel) {
        super();
        this.user = checklistResponse ? checklistResponse.user : new UserModel;
    }
}


// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/question_response.model copy.ts